import React, { useState } from "react";
import { Button, message } from "antd";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { AddressElement } from "@stripe/react-stripe-js";
import { savePaymentMethod } from "@/api/payment";
import { usePaymentStore } from "@/hooks/usePaymentStore";
import { useModalStore } from "@/hooks/useModalStore";
import { useTranslation } from "react-i18next";

interface StripeCardFormProps {
  onClose?: () => void;
}

const StripeCardFormContent: React.FC<StripeCardFormProps> = ({
  onClose,
}) => {
  const { t } = useTranslation();
  const { reQueryWalletData } = usePaymentStore();
  const { setShowModalAddPayment } = useModalStore();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formData, setFormData] = useState<any>({});
  const stripe = useStripe();
  const elements = useElements();
  const [addressComplete, setAddressComplete] = useState(false);

  const handleAddressChange = (event: any) => {
    const { complete, value } = event;
    setAddressComplete(complete);

    if (complete) {
      setFormData(value);
    } else {
      if (value.address) {
        setFormData(value.address);
      }
    }
  };

  const handleConfirm = async () => {
    if (!stripe || !elements) {
      return;
    }

    if (!addressComplete) {
      message.error(t("components.stripeCardFormContent.pleaseFillCompleteBillingAddress"));
      return;
    }

    const cardElement = elements.getElement(CardElement);
    if (!cardElement) {
      return;
    }

    setButtonLoading(true);
    try {
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: {
          name: formData.name, // 持卡人姓名
          address: formData.address,
        },
      });
      if (error) {
        message.error(error.message);
      } else {
        // 保存支付方式
        const res = await savePaymentMethod({
          paymentMethodId: paymentMethod.id,
        });
        //
        if (res.id) {
          message.success(t("components.stripeCardFormContent.cardBindingSuccessful"));
          setShowModalAddPayment(false);
          reQueryWalletData({ andLoading: false });
          onClose && onClose();
        } else if (res.message) {
          message.error(res.message);
        }
      }
    } catch (err) {
      message.error(t("components.stripeCardFormContent.errorDuringCardBinding"));
    } finally {
      setButtonLoading(false);
    }
  };

  return (
    <>
      <div className="pt-4 pb-6">
        <CardElement
          options={{
            style: {
              base: {
                fontSize: "16px",
                color: "#424770",
                "::placeholder": {
                  color: "#aab7c4",
                },
              },
              invalid: {
                color: "#9e2146",
              },
            },
            hidePostalCode: true, // 隐藏邮政编码字段
          }}
        />
      </div>

      {/*  */}
      <AddressElement
        options={{
          mode: "billing",
        }}
        onChange={handleAddressChange}
      />
      {/*  */}
      <Button
        type="primary"
        disabled={!addressComplete}
        loading={buttonLoading}
        onClick={handleConfirm}
        style={{ marginTop: "20px", width: "100%" }}
      >
        {t("components.stripeCardFormContent.submit")}
      </Button>
    </>
  );
};

export default StripeCardFormContent;
